import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
// import Home from '../views/Home.vue'
import Login from '../views/Login'
import Directorio from '../components/Directorio'
import Disposiciones from '../components/Disposiciones'
import Leyes from '../components/Documents'
import ConsejoDirectivo from '../components/ConsejoDirectivo'
import Anuncios from '../components/NuevosAnuncios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Anuncios',
    component: Anuncios
  },
  {
    path: '/directorio',
    name: 'Directorio',
    component: Directorio
  },
  {
    path: '/disposiciones',
    name: 'Disposiciones',
    component: Disposiciones
  },
  {
    path: '/leyes',
    name: 'Leyes',
    component: Leyes
  },
  {
    path: '/consejo',
    name: 'Consejo',
    component: ConsejoDirectivo
  },
  {
    path: '/inicio',
    name: 'Login',
    component: Login,
    meta: {
      isForLogin: true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // check to see if route requires auth
  if (to.matched.some(rec => rec.meta.isForLogin)) {
    console.log('isForLogin')
    let user = store.state.firUser
    if (user) {
      next({ name: 'Directorio' })
    } else {
      next()
    }
  } else {
    console.log('is anonymus, going next')
    let user = store.state.firUser
    let isAuthRequired = to.matched.some(rec => rec.meta.isAuthRequired);
    if (isAuthRequired && !user) {
      next({ name: 'Directorio' })
    } else {
      next()
    }

  }
})

export default router